import { createFileRoute } from '@tanstack/react-router';
import { JourneysTransactionalNewHandoff } from '@/pages/workspaces/transactional/new/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/transactional/new` URL, which forwards to the migrated page. The resolver
 * belongs here: this URL keeps the `journeys` segment, so a `/workspaces/last` sentinel resolves
 * against the embedded app's bundle before the forward builds its target.
 */
function JourneysTransactionalNewRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysTransactionalNewHandoff />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/transactional/new')({
  component: JourneysTransactionalNewRoute,
});
